import {put, select} from 'redux-saga/effects';
import TransactionTransferActions from '../actions';
import {TableName} from "../../EditableTable/options";

const { set, openItemModal, openTxnModal } = TransactionTransferActions;

export function* onInit(action) {
    const state = yield select();
    const { items } = state.Editable[TableName.form_item];
    const { originType, transactionType } = action;

    // Compute 'selections' from Editable Form Items
    const transferFromItems = items.filter(item => item.transfer_transaction);

    const selections = [];
    transferFromItems.forEach(transferFormItem => {
        const transactionId = transferFormItem.transfer_transaction.id;
        const transactionItemId = transferFormItem.transfer_item_id;

        const item = {
            id: transactionItemId,
            applyQty: transferFormItem.quantity,
        };

        const idx = selections.findIndex(t => t.transactionId === transactionId);
        if (idx >= 0) {
            selections[idx].items.push(item);
        }
        else {
            selections.push({
                transactionId,
                items: [item],
            });
        }
    });

    // Action Taken
    // 1. Set Initial Value
    yield put(
        set({
            originType,
            transactionType,
            selections,
        }),
    );

    // 2. Open Item Modal
    yield put(
        openItemModal(),
    );

    // 3. Open Transaction Modal
    if (selections.length === 0) {
        yield put(
            openTxnModal(),
        );
    }
}
